import { CdkAccordionModule } from '@angular/cdk/accordion';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInGuard } from '@digilize/shared/feature/modules/auth/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';
import { InlineSVGModule } from 'ng-inline-svg-2';

import { SharedModule } from '../components/shared.module';
import { DashboardComponent } from './dashboard/dashboard.component';

const dashboardRoutes: Routes = [
  {
    component: DashboardComponent,
    path: '',
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'my-questionnaires' },
      {
        path: 'my-questionnaires',
        loadChildren: () =>
          import('./my-questionnaires/my-questionnaires.module').then((m) => m.MyQuestionnairesModule),
        title: 'seo.title.my_questionnaires',
        canActivate: [LoggedInGuard],
        data: { customLoginRedirectRoute: '/auth' },
      },
      {
        path: 'research',
        loadChildren: () => import('./research/research.module').then((m) => m.ResearchModule),
        title: 'seo.title.research',
        canActivate: [LoggedInGuard],
        data: { customLoginRedirectRoute: '/auth' },
      },
    ],
  },
];
@NgModule({
  declarations: [DashboardComponent],
  imports: [
    CommonModule,
    SharedUiMaterialModule,
    CdkAccordionModule,
    SharedUiComponentsModule,
    InlineSVGModule,
    SharedModule,
    RouterModule.forChild(dashboardRoutes),
  ],
  exports: [DashboardComponent],
})
export class MainModule {}
